import { Component } from "react";

export default class ResultsPDF extends Component {

    generateLink(ident, displayName) {
        // Link to file in public folder
        var url = '' + process.env.PUBLIC_URL + '/' + ident;
        return <a href={url} target="_blank">{displayName}</a>
    }

    render() {
        return (
            <div className="results-pdf">
                <div className="page-content">
                    <h1>Ergebnisse</h1>
                    <article>
                        <ul>
                            <li>
                                {this.generateLink('pdf/Gemeindemeisterschaft_Ergebnisse_2025.pdf', 'Gemeindemeisterschaft 2025')}
                            </li>
                            <li>
                                {this.generateLink('pdf/Koenigsschiessen_Ergebnisse_2025.pdf', 'Königsschießen 2025')}
                            </li>
                            <li>
                                {this.generateLink('pdf/Gemeindemeisterschaft_Manschaft_2026.pdf', 'Gemeindemeisterschaft 2026 (Mannschaftswertung)')}
                            </li>
                            <li>
                                {this.generateLink('pdf/Gemeindemeisterschaft_Einzel_2026.pdf', 'Gemeindemeisterschaft 2026 (Einzelwertung)')}
                            </li>
                            <li>
                                {this.generateLink('pdf/Feierabendhock_Ergebnisse_2026.pdf', 'Feierabendhock 2026')}
                            </li>
                        </ul>
                    </article>
                </div>
            </div>
        );
    }
}